module.exports = __webpack_public_path__ + "img/deco-side.6ece31e2.svg";